import { render as renderDom } from 'react-dom'
import { withAppContext } from './utils/with-app-context.js'

delete window.__INITIAL_STATE__

export const render = ({ Routes }) => renderDom(withAppContext(<Routes />), document.querySelector('.js-root'))
